import { Form, Select } from "antd";
const SelectField = ({ name, placeholder, options, selectClasses }) => (
  <Form.Item name={name}>
    <Select
      placeholder={placeholder}
      className={`border-primary text-primary font-sans rounded-md h-[50px] ${
        selectClasses ? "border-1" : "border-2 custom-select"
      } ${selectClasses}`}>
      {options.map((option) => (
        <Select.Option key={option} value={option}>
          {option}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);

export default SelectField;
